import { render, staticRenderFns } from "./TransportVehicle.vue?vue&type=template&id=3ed729e3&scoped=true&"
import script from "./TransportVehicle.vue?vue&type=script&lang=js&"
export * from "./TransportVehicle.vue?vue&type=script&lang=js&"
import style0 from "./TransportVehicle.vue?vue&type=style&index=0&id=3ed729e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed729e3",
  null
  
)

export default component.exports